import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaMoon, FaSun } from "react-icons/fa";
import { navigateToSection } from "../utils/hashSectionNav";
import { useTheme } from "../context/ThemeContext";

const SCROLL_THRESHOLD = 24;

export const Navigation = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  const isLanding = location.pathname === "/" || location.pathname === "";

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > SCROLL_THRESHOLD);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("is-landing-route", isLanding);
    document.body.classList.toggle("is-inner-route", !isLanding);
    return () => {
      document.body.classList.remove("is-landing-route", "is-inner-route");
    };
  }, [isLanding]);

  // No topo da landing usamos a versão escura (logo claro) sobre o hero escuro.
  // Nas demais rotas, segue o tema (claro/escuro).
  const useDarkBgLogo = isLanding && !scrolled;
  const logoSrc = useDarkBgLogo
    ? "/img/core_bank_logos/transparent-backgrounds/02_horizontal_escuro_2400x960.png?v=20260513"
    : theme === "dark"
    ? "/img/core_bank_logos/transparent-backgrounds/02_horizontal_escuro_2400x960.png?v=20260513"
    : "/img/core_bank_logos/transparent-backgrounds/01_horizontal_claro_4800x1920_print-Photoroom.png?v=20260513";

  const goToSection = (e, sectionId) => {
    e.preventDefault();
    navigateToSection(navigate, location, sectionId);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  const urlRegister = props.data ? "https://app." + props.data.nameBankDomain + ".com.br/register" : "indefinido";
  const urlLogin = props.data ? "https://app." + props.data.nameBankDomain + ".com.br/login" : "indefinido";
  
  const navClass = [
    "navbar navbar-default navbar-fixed-top nav-modern",
    isLanding ? "nav-landing" : "nav-inner",
    scrolled ? "is-scrolled" : "is-top",
  ].join(" ");

  return (
    <nav id="menu" className={navClass}>
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-label="Abrir menu"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="/" aria-label="CORE bank — Digital Banking">
            <img
              src={logoSrc}
              alt={props.data ? props.data.nameBank : "CORE bank"}
              className="styled-logo"
            />
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right ul-limited">
            <li>
              <a
                href="#about"
                className="page-scroll"
                onClick={(e) => goToSection(e, "about")}
              >
                Sobre
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                onClick={(e) => goToSection(e, "services")}
              >
                Para empresas
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                onClick={(e) => goToSection(e, "services")}
              >
                Para você
              </a>
            </li>
            <li className="nav-cta-wrap">
              <div className="nav-cta">
                <button
                  type="button"
                  className="btn nav-cta-btn nav-cta-btn--ghost"
                  onClick={() => openInNewTab(urlLogin)}
                  aria-label="Acessar minha conta CORE bank"
                >
                  Acessar conta
                </button>
                <button
                  type="button"
                  className="btn nav-cta-btn nav-cta-btn--primary"
                  onClick={() => openInNewTab(urlRegister)}
                  aria-label="Abrir uma nova conta CORE bank"
                >
                  Abrir conta
                </button>
              </div>
            </li>
            <li className="nav-theme-toggle-wrap">
              <button
                type="button"
                className="nav-theme-toggle"
                onClick={toggleTheme}
                aria-label={
                  theme === "dark"
                    ? "Ativar tema claro"
                    : "Ativar tema escuro"
                }
                title={theme === "dark" ? "Tema claro" : "Tema escuro"}
              >
                {theme === "dark" ? <FaSun /> : <FaMoon />}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
